import { RACE_REGION_ENUMS } from './const';
/**
 * Get the correct race region enum
 * @param {string} region - string of the race
 * @returns {import('./interfaces').TRaceRegionValues}
 */
export function getRaceRegionEnum(region) {
  return RACE_REGION_ENUMS[region] || 'uk';
}